// 新闻详情（移动端）
<template>
  <div class="cmain">
    <div class="top">
      <span class="back" @click="back"></span>
      <h1>新闻详情</h1>
    </div>
    <div class="center">
      <h1 class="title">{{ this.newsDtlList.title }}</h1>
      <p class="timeDetail">发布时间：{{ this.newsDtlList.pushtime | dateformat('YYYY-MM-DD') }}</p>
      <p class="textMain" v-html="this.newsDtlList.newcontent"></p>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {
      newid: "",
      newsDtlList:{},
    };
  },
  mounted() {
    this.newid = this.$route.query.newid;
    this.newsDetailData();
    if (this.isMobile()) {
      //移动端跳转路由
      this.$router.push({
        path: "/mNewsDetail",
        query: {
          newid: this.newid,
        },
      }); 
    } else {
      //Pc端跳转路由
      this.$router.push({
        path: "/newsDetial",
        query: {
          newid: this.newid,
        },
      });
    }
  },
  methods: {
    // 获取新闻详情
    newsDetailData() {
      const _this = this;
      this.$axios({
        url: "http://192.168.10.206:11003/pushnews/queryInfo",
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          newid: this.newid
        },
      }).then((response) => {
        this.newsDtlList = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },


    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    back() {
      this.$router.replace("/mNews");
    },
  },
  components: {
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  margin-top: 0rem;
  .top {
    width: 100%;
    height: 3rem;
    line-height: 3rem;
    position: relative;
    .back {
      display: block;
      width: 1.2rem;
      height: 1.2rem;
      background: url("../../assets/img/mobile/micon/返回.svg") 0 0 no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0.9rem;
      left: 0.5rem;
    }
    h1 {
      text-align: center;
      opacity: 1;
      font-size: 1rem;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      color: #221815;
    }
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 500;
      text-align: left;
      color: #000000;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .timeDetail {
      height: 1rem;
      opacity: 1;
      font-size: 0.5rem;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      text-align: justifyLeft;
      color: #999999;
      border-bottom: 0.1rem solid #4279db;
      margin-bottom: 1.3rem;
    }
    .textMain {
      opacity: 1;
      font-size: 0.7rem;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      text-align: justifyLeft;
      color: #000000;
      line-height: 1.7rem;
      text-indent: 2em;
    }
  }
}
.textMain img{
  width: 1rem;
  height: 1rem;
}
</style>
